export default __webpack_public_path__ + "static/media/video_call.5a34e02d.svg";